import { getCurrentConference } from '../base/conference/functions';
import { getAiParticipant } from '../deepai-theme/functions';
import { SET_CHAT_HISTORY_VISIBLE, SET_CHAT_HISTORY_DATA, SET_SELECTED_CONVERSATION, SET_CONVERSATIONS_LIST, SET_CHAT_HISTORY_POLLING, SET_CHAT_HISTORY_LOADING, SET_CHAT_HISTORY_ERROR, ADD_CHAT_HISTORY_MESSAGES, SET_CHAT_HISTORY_LAST_UPDATED, STT_UPSERT_INTERIM, STT_COMMIT_FINAL, STT_CLEAR_TRANSCRIPTS, AI_RESPONSE_APPEND, AI_RESPONSE_FINAL } from './actionTypes';
/**
 * Sets the visibility of the chat history panel
 */
export function setChatHistoryVisible(visible) {
    return {
        type: SET_CHAT_HISTORY_VISIBLE,
        visible
    };
}
/**
 * Sets the chat history data
 */
export function setChatHistoryData(data) {
    return {
        type: SET_CHAT_HISTORY_DATA,
        data
    };
}
/**
 * Sets the selected conversation
 */
export function setSelectedConversation(conversationId) {
    return {
        type: SET_SELECTED_CONVERSATION,
        conversationId
    };
}
/**
 * Sets the conversations list
 */
export function setConversationsList(conversations) {
    return {
        type: SET_CONVERSATIONS_LIST,
        conversations
    };
}
/**
 * Sets the polling state
 */
export function setChatHistoryPolling(polling) {
    return {
        type: SET_CHAT_HISTORY_POLLING,
        polling
    };
}
/**
 * Sets the loading state
 */
export function setChatHistoryLoading(loading) {
    return {
        type: SET_CHAT_HISTORY_LOADING,
        loading
    };
}
/**
 * Sets the error state
 */
export function setChatHistoryError(error) {
    return {
        type: SET_CHAT_HISTORY_ERROR,
        error
    };
}
/**
 * Adds new messages to the chat history
 */
export function addChatHistoryMessages(messages) {
    return {
        type: ADD_CHAT_HISTORY_MESSAGES,
        messages
    };
}
/**
 * Sets the last update timestamp
 */
export function setChatHistoryLastUpdated(timestamp) {
    return {
        type: SET_CHAT_HISTORY_LAST_UPDATED,
        timestamp
    };
}
/**
 * Upserts a participant's in-progress (interim) STT line. Overwrites the
 * previous interim for the same participant — do not append.
 */
export function upsertInterimTranscript(line) {
    return {
        type: STT_UPSERT_INTERIM,
        line
    };
}
/**
 * Commits a final STT line: appends it to the accumulated log and clears the
 * matching participant's interim line.
 */
export function commitFinalTranscript(line) {
    return {
        type: STT_COMMIT_FINAL,
        line
    };
}
/**
 * Clears all accumulated transcripts and interims (e.g. on leaving).
 */
export function clearTranscripts() {
    return {
        type: STT_CLEAR_TRANSCRIPTS
    };
}
/**
 * Appends a streaming AI-response chunk (concatenated by generation_id).
 */
export function appendAiResponse(payload) {
    return {
        type: AI_RESPONSE_APPEND,
        ...payload
    };
}
/**
 * Commits the final full AI response (replaces the streaming line and appends
 * it to the log).
 */
export function commitAiResponse(payload) {
    return {
        type: AI_RESPONSE_FINAL,
        ...payload
    };
}
/**
 * Sends the accumulated conversation transcript to the AI participant over
 * the bridge data channel as a "feedback" command. The AI backend
 * (consciousness server) analyses the conversation and returns a PDF report
 * URL via PDF_SLIDE_URL, which opens in the slide panel.
 *
 * @returns {Function}
 */
export function sendConversationFeedback() {
    // ★2026-10-12 送れたかを true/false で返す。呼び側が進行ポップアップを出すか失敗にするかを決める。
    return (_dispatch, getState) => {
        const state = getState();
        const conference = getCurrentConference(state);
        const ai = getAiParticipant(state);
        // NOTE: functions.ts 経由だと actions→functions→reducer→actions の循環に
        // なるため、transcripts はストアから直接読む。
        const transcripts = (state['features/chat_history']?.transcripts || []);
        if (!conference || !ai) {
            console.warn('[chat-history] feedback: no conference or AI participant');
            return false;
        }
        const history = transcripts.slice(-50)
            .map(l => {
            return {
                name: String(l.name || '').slice(0, 40),
                role: l.isAi ? 'ai' : 'user',
                text: String(l.text || '').slice(0, 1000),
                ts: l.ts
            };
        })
            .filter(h => h.text);
        if (!history.length) {
            console.warn('[chat-history] feedback: no transcripts yet');
            return false;
        }
        try {
            conference.sendEndpointMessage(ai.id, {
                client_ts: Date.now(),
                history,
                type: 'feedback'
            });
            console.log('[chat-history] feedback sent (' + history.length + ' turns)');
            return true;
        }
        catch (e) {
            console.error('[chat-history] feedback: failed to send', e);
            return false;
        }
    };
}
